import { combineReducers } from 'redux';
import userReducer from './userReducer';
import personalApiKeyReducer from './personalApiKeyReducer';
import assistantDownloadReducer from './assistantDownloadReducer';

const usersReducer = combineReducers({
  users: userReducer,
  personalApiKeys: personalApiKeyReducer,
  assistantDownloads: assistantDownloadReducer,
});

export default usersReducer;
